var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-group rounded w-100"},_vm._l((_vm.langs),function(item,i){return _c('router-link',{key:i,staticClass:"btn border",class:{
      'wet-switch-lang-active': _vm.lang === item.lang
    },attrs:{"to":{
      params: { ..._vm.$route.props, lang: item.lang === 'en' ? null : item.lang }
    },"type":"button"}},[_c('img',{staticClass:"me-2",attrs:{"alt":item.title,"src":item.icon,"width":"18","height":"12"}}),_vm._v(" "+_vm._s(item.title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }